import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next';
import 'styled-components/macro'
import Radio from '@material-ui/core/Radio'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import { FlexContainer, SliderInput, Label, SelectInput } from 'heliocor-ui'
import WarningBox from '../../common/WarningBox';


const AddEntity = ({
    relationChangeHandler, setLookupType, setTypeOfNewEntity, typeOfNewEntity, onSelectSubsidiary,
    values = {}, sliderMax, isEdit, isLookup, setTypeOfEntity, canEdit = true, isOwnershipAllowed
}) => {

    const { t } = useTranslation()
    const handleChange = name => event => {
        const checked = event.target.checked
        if (isEdit && !checked) setRelationWarningState({ open: true, name, value: checked })
        else relationChangeHandler(name, checked)
    }

    const entity = isEdit ? values.type : typeOfNewEntity
    const isStructureEdit = isEdit && !isLookup

    const onChangeEntity = value => {
        if (isLookup) {
            setLookupType(value)
            setTypeOfNewEntity(value)
        } else {
            setTypeOfNewEntity(value)
        }
    }

    const party = useSelector(store => store.party)

    const [relatinoWarningState, setRelationWarningState] = useState({})


    useEffect(() => {
        if (isLookup) { setTypeOfEntity(values.type) }
    }, [values, setTypeOfEntity, isLookup, isEdit])

    useEffect(() => {
        if (isEdit && !typeOfNewEntity) { setTypeOfNewEntity(values.type) }
    }, [values, setTypeOfNewEntity, isEdit, typeOfNewEntity])

    //Force the renaming of fields at beggining
    useEffect(() => {
        if (typeOfNewEntity) setLookupType(typeOfNewEntity)
    }, [typeOfNewEntity])

    const getOwnableCompanies = () =>
        [{ value: party.data.identifier || 'parent', label: party.data.name, level: -1 }]
            .concat(party.connectedParties
                .filter(cp => cp.type === 'COMPANY')
                .map(company => ({ value: company.identifier, label: company.name, level: company.level }))
            )

    return (
        <FlexContainer column alignItems='center'>
            <FlexContainer width='100%' justifyContent='flex-start' column
                css='&&{padding:1rem; align-items:flex-start; @media (min-width: 740px){padding: 1rem 2.7rem 0 2.7rem;}}'
            >
                <Label customLabel={t('relatedCompany')} />
                <div style={{ width: '100%' }}>
                    <SelectInput
                        disabled={!canEdit}
                        options={getOwnableCompanies()}
                        onChange={(id, opt) => opt && onSelectSubsidiary(opt.value, opt.level)}
                        value={values.parentId || 'parent'}
                        customLabel=' '
                    />
                </div>
            </FlexContainer>
            <FlexContainer
                width='100%'
                justifyContent='flex-start' 
                css='&&{padding:1rem; align-items:flex-start; @media (min-width: 740px){padding: 0 2.7rem;}}'
                column
            >
                <Label customLabel={t('type')} />
                <FlexContainer>
                    <FormControlLabel
                        data-cy="add-person-radio"
                        control={<Radio disabled={isStructureEdit} checked={entity === 'PERSON' || false} />}
                        label={t('individual')}
                        onChange={() => onChangeEntity('PERSON')}
                        css='&&{width:120px; @media (min-width: 740px){width: 150px;}}'
                    />
                    <FormControlLabel
                        data-cy="add-company-radio"
                        control={<Radio disabled={isStructureEdit} checked={entity === 'COMPANY' || false} />}
                        label={t('legalEntity')}
                        onChange={() => onChangeEntity('COMPANY')}
                        css='&&{width:120px; @media (min-width: 740px){width: 150px;}}'
                    />
                </FlexContainer>
            </FlexContainer>
            <FlexContainer
                width='100%'
                justifyContent='flex-start'
                css='&&{padding:1rem; align-items:flex-start; @media (min-width: 740px){padding: 1rem 2.7rem;}}'
                column
            >
                <Label customLabel={t('relation')} />
                <FlexContainer css='&&{@media (max-width: 740px){flex-direction: column;}}'>
                    <FormControlLabel

                        data-cy="select-authorizedSignatory-checkbox"
                        control={<Checkbox
                            checked={(values?.authorizedSignatory) || false}
                            onChange={handleChange('authorizedSignatory')}
                            value="authorizedSignatory"
                            disabled={(entity === "COMPANY" || !canEdit) || !typeOfNewEntity}
                        />}
                        label={t('authorizedSignatory')}
                        css='&&{width:300px; @media (min-width: 740px){width: 206px;}}'
                    />
                    <FormControlLabel
                        data-cy="select-director-checkbox"
                        control={<Checkbox
                            checked={(values?.director) || false}
                            onChange={handleChange('director')}
                            value="director"
                            disabled={!canEdit || !typeOfNewEntity}
                        />}
                        label={t('director')}
                        css='&&{width:300px; @media (min-width: 740px){width: 120px;}}'
                    />
                    <FormControlLabel
                        data-cy="select-shareholder-checkbox"
                        control={<Checkbox
                            checked={(values?.shareholder) || false}
                            onChange={handleChange('shareholder')}
                            value={'shareholder'}
                        />}
                        disabled={(sliderMax === 0 || !canEdit) || !typeOfNewEntity}
                        label={t('shareholder')}
                        css='&&{width:300px; @media (min-width: 740px){width: 140px;}}'
                    />
                    <FormControlLabel
                        data-cy="select-ubo-checkbox"
                        control={<Checkbox
                            checked={(values?.ubo) || false}
                            onChange={handleChange('ubo')}
                            value={'ubo'}
                        />}
                        disabled={(sliderMax === 0 || !canEdit) || !typeOfNewEntity}
                        label={t('ubo')}
                        css='&&{width:300px; @media (min-width: 740px){width: 276px;}}'
                    />
                </FlexContainer>
            </FlexContainer>
            {isOwnershipAllowed &&
                <FlexContainer responsive width='100%' column
                    css='&&{padding:1rem; align-items:flex-start; @media (min-width: 740px){padding: 1rem 2.7rem;}}'
                >
                    <SliderInput
                        id='ownership'
                        label={t('ownership')}
                        value={values.ownership}
                        max={sliderMax}
                        onChange={relationChangeHandler}
                    />
                </FlexContainer>
            }
            <WarningBox
                key="deleteWarning"
                open={relatinoWarningState.open}
                onClose={() => setRelationWarningState({ open: false })}
                title={t("confirmationRequired")}
                content={t("warning.editCPConfirmation")}
                buttons={[
                    {
                        type: 'default',
                        onClick: () => relationChangeHandler(relatinoWarningState.name, relatinoWarningState.value, true) & setRelationWarningState({ open: false }),
                        value: t('button.continue')
                    },
                    {
                        type: 'light',
                        onClick: () => setRelationWarningState({ open: false }),
                        value: t('button.cancel')
                    }
                ]}
            />
        </FlexContainer>
    )
}

export { AddEntity }